export const en = {
    bannersEdit: 'Editing ads',
    campaignsEdit: 'Edit campaigns',
    clientHistory: 'Changelog',
    clientsReports: 'Report on clients',
    deals: 'List of deals',
    domainsReports: 'Report on domains',
    freelancerCard: 'Yandex.Direct expert',
    freelancerCardEdit: 'Expert profile',
    freelancerCustomers: 'Client list',
    freelancersList: 'Yandex.Direct setup experts',
    groupsEdit: 'Editing ad groups',
    'import-export-wizard': 'Data Import/Export wizard',
    marketerCard: 'Market expert card',
    marketers: 'Manage market experts',
    minusPhrasesLibrary: 'Negative keyword library',
    mobileAppsCreate: 'Add mobile app',
    mobileAppsEdit: 'View app',
    mobileAppsList: 'Mobile apps',
    myVideos: 'My videos',
    offlineReports: 'Offline reports',
    pricePackages: 'Packages',
    pricePackagesEdit: 'todo',
    products: 'Manage products',
    recommendationsItems: 'Recommendations',
    recommendationsPage: 'Recommendations',
    tools: 'Tools',
    'user-settings': 'User settings',
    videoCreate: 'Video create',
    videoTemplates: 'Templates',
    welcome: 'Welcome to Yandex.Direct'
};
